import { render, staticRenderFns } from "./IcoFacebookLogo.vue?vue&type=template&id=4a5b2853"
import script from "./IcoFacebookLogo.vue?vue&type=script&lang=js"
export * from "./IcoFacebookLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports